import { render, staticRenderFns } from "./review-grid-02.vue?vue&type=template&id=a7b0f380&scoped=true&"
import script from "./review-grid-02.vue?vue&type=script&lang=js&"
export * from "./review-grid-02.vue?vue&type=script&lang=js&"
import style0 from "./review-grid-02.vue?vue&type=style&index=0&id=a7b0f380&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b0f380",
  null
  
)

export default component.exports